import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "../../redux/supervisorSlice";
import { selectionTypes } from "../utils/consts";
import WidgetTools from "./widgetTools";

function QueueCallsSummary(props) {

    const { t } = useTranslation();
    const [calls, setCalls] = useState(0);
    const [waiting, setWaiting] = useState("00:00");
    const [averageWait, setAverageWait] = useState("00:00");
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`QueueCallsSummary_groupName_${props.identifier}_user${props.id}`) || t("all2"));


    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/queuesummary", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("queuesummary");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {

            let groupId = parseInt(localStorage.getItem(`QueueCallsSummary_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/queuesummary/`, function (callssummary) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    var data = JSON.parse(callssummary.body);
                    let avg = new Date(data.averageQueueCallDuration * 1000).toISOString().slice(14, 19),
                        max = new Date(data.maxActiveDuration * 1000).toISOString().slice(14, 19);

                    setCalls(data.maxQueuedCall);
                    setWaiting(max);
                    setAverageWait(avg);
                }
            }, { id: "queuesummary" });

            MonitorWSService.stompClient.send("/app/subscribe/queuesummary", {}, JSON.stringify({
                token: props.token,
                groupId: groupId
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroup = (groupId, groupName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        localStorage.setItem(`QueueCallsSummary_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`QueueCallsSummary_groupName_${props.identifier}_user${props.id}`, groupName);
        MonitorWSService.stompClient.send("/app/subscribe/queuesummary", {}, JSON.stringify({
            token: props.token,
            groupId: groupId
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} >
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-volume")} /> {t("queuecalls")} - {groupName}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col lg={4} md={4} sm={4} xs={4}>
                        <div className="fs-3hx fw-bold text-gray-800 statsnumber">{calls}</div>
                        <div className="fs-6 fw-semibold mb-7">{t("totalqueuedcalls")}</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4}>
                        <div className="fs-2hx fw-bold text-gray-800 statsnumber">{waiting}</div>
                        <div className="fs-6 fw-semibold mb-7">{t("maxqueuedtime")}</div>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4}>
                        <div className="fs-2hx fw-bold text-gray-800 statsnumber">{averageWait}</div>
                        <div className="fs-6 fw-semibold mb-7">{t("avgqueuedtime")}</div>
                    </Col>
                </Row>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroup={setGroup} groupId={groupId} groupName={groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { removeWidget })(QueueCallsSummary);